import { Root } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
export var Dialog = function Dialog(_ref) {
  var children = _ref.children,
    container = _ref.container,
    header = _ref.header,
    id = _ref.id,
    onClose = _ref.onClose,
    open = _ref.open,
    zIndex = _ref.zIndex;
  return /*#__PURE__*/_jsx(Root, {
    container: container,
    header: header,
    id: id,
    open: open !== null && open !== void 0 ? open : false,
    size: "small",
    zIndex: zIndex,
    onClose: onClose,
    children: children
  });
};